
import Vue from "vue";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";

interface Comment {
  id: string
  twitterId: string
  screenName: string
  name: string
  userImageUrl?: string
  mediaUrl?: string
  displayUrl?: string
  commentText: string
  tweetedAt: string
}

class CommentUser {
  public comments: Comment[] = [];

  public latestTimestamp: string = "";

  constructor(public readonly twitterId: string, comments: Comment[]) {
    comments.forEach((v) => {
      if (v.twitterId === twitterId) {
        this.comments.push(v);
        if (!this.latestTimestamp || v.tweetedAt > this.latestTimestamp) {
          this.latestTimestamp = v.tweetedAt;
        }
      }
    });
    this.comments.sort((a, b) => a.tweetedAt < b.tweetedAt ? -1 : 1);
  }

  get userImageUrl() { return this.comments[0].userImageUrl; }

  get name() { return this.comments[0].name; }

  get screenName() { return this.comments[0].screenName; }
}

interface DataType {
  userMap: { [key: string]: CommentUser }
}

interface MethodType {}

interface ComputedType {
  users: CommentUser[]
}

interface PropType {}

export default Vue.extend({
  name: "birthday",
  data() {
    return ({
      userMap: {},
    }) as DataType;
  },
  created() {
    const hash = location.href.split("/").pop();
    fetch(`/api/birthday/list/${hash}`).then(res => res.json()).then((comments: Comment[]) => {
      const map: { [key: string]: CommentUser } = {};
      comments.forEach((v) => {
        console.log("test1", v.commentText);
        v.commentText = v.commentText.replace(/https:\/\/t\.co\/\w+/, "");
        console.log("test2", v.commentText);
        if (!this.userMap[v.twitterId]) {
          map[v.twitterId] = new CommentUser(v.twitterId, comments);
        }
      });
      this.userMap = map;
    });
  },
  computed: {
    users() {
      return Object.keys(this.userMap).map(
        k => this.userMap[k],
      ).sort(
        (a, b) => a.latestTimestamp > b.latestTimestamp ? -1 : 1,
      );
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, PropType>);
